import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { DeleteProject, DeleteProjectVariables } from "./__generated__/DeleteProject";
import { CORE_PROJECT_FIELDS } from "../fragments/project";

const DELETE_PROJECT = gql`
  ${CORE_PROJECT_FIELDS}
  mutation DeleteProject($projectId: String!, $organizationId: String!) {
    deleteProject(input: { projectId: $projectId, organizationId: $organizationId }) {
      project {
        ...CoreProjectFields
      }
    }
  }
`;

export function useDeleteProject() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    DeleteProject,
    DeleteProjectVariables
  >(DELETE_PROJECT, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
